const CUIT_WEIGHTS = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2];
// Type prefixes: personas físicas (20-27) and personas jurídicas (30-34).
const CUIT_PREFIXES = ["20", "23", "24", "25", "26", "27", "30", "33", "34"];

/**
 * Keeps only the digits of an Argentine CUIT/CUIL, at most 11.
 */
export const cleanCuit = (value: string): string => {
  if (!value) return "";
  return value.replace(/\D/g, "").slice(0, 11);
};

/**
 * Formats a CUIT as "XX-XXXXXXXX-X" (e.g. "20-10563164-3").
 */
export const formatCuit = (value: string): string => {
  const digits = cleanCuit(value);
  if (digits.length <= 2) return digits;
  if (digits.length <= 10) return `${digits.slice(0, 2)}-${digits.slice(2)}`;
  return `${digits.slice(0, 2)}-${digits.slice(2, 10)}-${digits.slice(10)}`;
};

/**
 * Validates an Argentine CUIT/CUIL (11 digits), including its type prefix
 * and mod-11 check digit.
 */
export const checkCuit = (cuit: string): boolean => {
  if (!cuit) return false;

  const digits = cleanCuit(cuit);
  if (digits.length !== 11) return false;
  if (!CUIT_PREFIXES.includes(digits.slice(0, 2))) return false;

  const total = digits
    .slice(0, 10)
    .split("")
    .reduce(
      (acc, digit, index) => acc + Number(digit) * CUIT_WEIGHTS[index],
      0,
    );
  let expected = 11 - (total % 11);
  if (expected === 11) expected = 0;
  else if (expected === 10) expected = 9;

  return Number(digits.charAt(10)) === expected;
};
